
























































import AuthUtils from '@/utils/AuthUtils';
import UserAgreementUtils, { UserAgreement } from '@/utils/UserAgreementUtils';
import mixins from 'vue-typed-mixins';
export default mixins().extend({
  props: {},

  computed: {
    useragreements(): UserAgreement[] {
      return this.$session?.useragreements || [];
    },

    visible(): boolean {
      return this.useragreements.length > 0; // if there are any agreements in the session they must be accepted
    },

    canSubmit(): boolean {
      return this.data?.every((item) => item.checkbox);
    },
  },

  data(): {
    data: {
      useragreement: UserAgreement;
      checkbox: boolean;
    }[];
  } {
    return {
      data: [],
    };
  },

  mounted() {
    this.data = this.useragreements.map((useragreement) => ({
      useragreement: useragreement,
      checkbox: false,
    }));
  },

  methods: {
    async submit() {
      try {
        (this.$refs.alert as any).hide('submit');
        await UserAgreementUtils.api.accept();
      } catch (error) {
        (this.$refs.alert as any).show('submit', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    async cancel() {
      await AuthUtils.clear();
      await this.$router.push({ name: 'login' });
    },
  },
});
